import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from 'app/app.component';
import { appConfig } from 'app/app.config';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import localeFrExtra from '@angular/common/locales/extra/fr';
// Enregistrer la locale française
registerLocaleData(localeFr, 'fr-FR', localeFrExtra);

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
